import { render, staticRenderFns } from "./Testbokgi.vue?vue&type=template&id=17a27058&"
import script from "./Testbokgi.vue?vue&type=script&lang=js&"
export * from "./Testbokgi.vue?vue&type=script&lang=js&"
import style0 from "./Testbokgi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports